/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import { AUTHORIZATION } from '@constants/general'

const privateRouter = ({ component: Component, layout: Layout, ...rest }) => (
  <Route {...rest} render={(props) =>
      localStorage.getItem(AUTHORIZATION)
        ? (
          Layout
            ? ( <Layout {...props}> {' '} <Component {...props} />{' '} </Layout> )
            : ( <Component {...props} /> )
        )
        : <Redirect to={{ pathname: '/', state: { from: props.location } }} />
    }
  />
);

export default privateRouter;
